"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ColorNotValidException extends Error {
    constructor(color, types) {
        super(`Il colore '${color}' non è valido.\nI formati supportati sono: ${types.map(e => e.type).join(', ')}`);
    }
}
exports.ColorNotValidException = ColorNotValidException;
class ColorParsingException extends Error {
    constructor(color) {
        super(`Impossibile convertire il colore '${color}'`);
    }
}
exports.ColorParsingException = ColorParsingException;
//# sourceMappingURL=ColorExceptions.js.map